import RecordsImportPage from './RecordsImportPage';

export default RecordsImportPage;